export enum DesignatedStatus {
  Pending = "pending",
}
